"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChainflexImportPneumaticHoses = exports.ChainflexImportPneumaticHosesSchema = void 0;
const zod_1 = require("zod");
const ChainflexImport_1 = require("./ChainflexImport");
const echain_prisma_client_1 = require("@igus/echain-prisma-client");
exports.ChainflexImportPneumaticHosesSchema = ChainflexImport_1.ChainflexImportSchema.omit({ crossSection: true }).extend({
    categories: zod_1.z.custom((cats) => {
        if (!Array.isArray(cats))
            return false;
        return cats.includes(echain_prisma_client_1.ChainflexCategory.PneumaticHoses);
    }),
});
const isChainflexImportPneumaticHoses = (whatever) => {
    var _a;
    return (_a = exports.ChainflexImportPneumaticHosesSchema.safeParse(whatever)) === null || _a === void 0 ? void 0 : _a.success;
};
exports.isChainflexImportPneumaticHoses = isChainflexImportPneumaticHoses;
//# sourceMappingURL=ChainflexImportPneumaticHoses.js.map